import { render, staticRenderFns } from "./DigitalAlbum.vue?vue&type=template&id=2179939a&scoped=true"
import script from "./DigitalAlbum.vue?vue&type=script&lang=js"
export * from "./DigitalAlbum.vue?vue&type=script&lang=js"
import style0 from "./DigitalAlbum.vue?vue&type=style&index=0&id=2179939a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179939a",
  null
  
)

export default component.exports